export default __webpack_public_path__ + "static/media/LOGO_KONVIX_H.d7b22470.png";